import { render, staticRenderFns } from "./EventHealthScreening.vue?vue&type=template&id=2762909e&"
import script from "./EventHealthScreening.vue?vue&type=script&lang=js&"
export * from "./EventHealthScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports